export function Header() {
  return (
    <header className="pointer-events-none absolute top-0 left-0 right-0 z-20 px-4 pt-4 md:px-6 md:pt-6">
      <div className="pointer-events-auto inline-block rounded border border-phosphor-800/70 bg-black/70 px-3 py-2 backdrop-blur-sm">
        <div className="text-[10px] uppercase tracking-[0.22em] text-phosphor-700">
          Phase 04 · Temporal Dimension and Correlation
        </div>
        <h1 className="text-sm font-semibold tracking-wide text-phosphor-300 md:text-base">
          Compute · labs · fabs · regulation · supply · money · patents · controls · co-authorship
        </h1>
      </div>
    </header>
  );
}
